import { useMutation } from '@apollo/client';
import { Mutations, Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useSubmitW4 = () => {
  const context = useAuthContext();
  const [mutate] = useMutation(Mutations.submitW4DocusignerDocument, {
    context,
    refetchQueries: [{ query: Queries.getMyW4s, context }],
  });
  const submitW4 = input => mutate({ variables: { input } });
  return [submitW4];
};

export default useSubmitW4;
